import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=bbd48b54&scoped=true"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"
import style0 from "./CommandPalette.vue?vue&type=style&index=0&id=bbd48b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd48b54",
  null
  
)

export default component.exports